import { isE2ERunning } from './configuration';

export const shouldSkipIntercom = () =>
    import.meta.env.MODE === 'test' ||
    import.meta.env.VITE_REACT_APP_IS_EXTENSION === 'true' ||
    isE2ERunning();
